
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';
import { useTheme } from '@/contexts/ThemeContext';
import { useScrollPosition } from '@/hooks/useScrollPosition';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  const isMobile = useIsMobile();
  const { resolvedTheme } = useTheme();
  const isScrolled = useScrollPosition({ threshold: 80 });
  
  // Use different logo based on theme
  const logoSrc = resolvedTheme === 'dark' 
    ? "/lovable-uploads/e0860118-659d-4f83-a9bf-4d16823ced7b.png" // Dark theme logo
    : "/lovable-uploads/6ba89a66-4744-4fbc-8a6c-aea02dd5dafb.png"; // Light theme logo
  
  // Mobile logos with different versions for light/dark mode
  const darkMobileLogo = "/lovable-uploads/0478f0f4-6d1c-4e90-b08a-6bc2b74cd16c.png"; // Dark theme mobile logo
  const lightMobileLogo = "/lovable-uploads/565cc476-7467-44f1-842d-4aa29cf60319.png"; // New light theme mobile logo
  
  // Select the appropriate mobile logo based on theme
  const mobileLogo = resolvedTheme === 'dark' ? darkMobileLogo : lightMobileLogo;

  return (
    <Link to="/" className={cn(className)}>
      {isMobile ? (
        <div className="relative h-10 min-w-[145px] overflow-hidden m-0 p-0">
          {/* Full logo - slides down when scrolled */}
          <img 
            src={logoSrc}
            alt="Everhouse" 
            className={cn(
              "absolute top-0 left-0 h-10 w-auto object-contain transition-transform duration-300 ease-out m-0 p-0",
              isScrolled 
                ? "translate-y-12" 
                : "translate-y-0"
            )}
          />
          {/* Compact logo - slides up when scrolled */}
          <img 
            src={mobileLogo} 
            alt="Everhouse Mobile Logo" 
            className={cn(
              "absolute top-1/2 left-0 h-[27px] w-auto object-contain transition-transform duration-300 ease-out m-0 p-0",
              isScrolled 
                ? "-translate-y-1/2" 
                : "translate-y-full"
            )}
          />
        </div>
      ) : (
        <img 
          src={logoSrc}
          alt="Everhouse" 
          className="h-9 w-[141px] m-0 p-0 object-contain"
        />
      )}
    </Link>
  );
};

export default Logo;
